registerGlobal( 'EmscriptenInput' );

EmscriptenInput.initialValue = "";
EmscriptenInput.xIframe = 0;
EmscriptenInput.yIframe = 0;
EmscriptenInput.wIframe = 0;
EmscriptenInput.hIframe = 0;
EmscriptenInput.hText = 0;

EmscriptenInput.xIframeBase = 0;
EmscriptenInput.yIframeBase = 0;
EmscriptenInput.wIframeBase = 0;
EmscriptenInput.hIframeBase = 0;
EmscriptenInput.hTextBase = 0;
EmscriptenInput.fontSizeBase = 0;
EmscriptenInput.scaleBase = 0;

EmscriptenInput.iframe_current = null;
EmscriptenInput.iframe_singleline = document.getElementById("inputfield");
EmscriptenInput.iframe_multiline = document.getElementById("inputfield_ml");

EmscriptenInput.ingameHeight = 0; // used to resize in-game graphics

EmscriptenInput.resize = function(event) {
    var iframe = EmscriptenInput.iframe_current;
    if (!iframe)
        return;

    // first, transform values from current canvas space to original canvas space
    // (dividing it by EmscriptenInput.scaleBase)
    // secondly, transform them to the page space in case canvas is scaled in css
    // (multiplying by getCanvasStyleScale())
    var scale = EmscriptenFullscreen.getCanvasStyleScale() / EmscriptenInput.scaleBase;

    EmscriptenInput.xIframe = EmscriptenInput.xIframeBase * scale;
    EmscriptenInput.yIframe = EmscriptenInput.yIframeBase * scale;
    EmscriptenInput.wIframe = EmscriptenInput.wIframeBase * scale;
    EmscriptenInput.hIframe = EmscriptenInput.hIframeBase * scale;
    EmscriptenInput.hText = EmscriptenInput.hTextBase * scale;

    iframe.style.left = EmscriptenInput.xIframe + 'px';
    iframe.style.top = EmscriptenInput.yIframe + 'px';
    iframe.style.width = EmscriptenInput.wIframe + 'px';
    iframe.style.height = EmscriptenInput.hIframe + 'px';

    var obj = iframe.contentDocument.getElementById('inputfield');
    obj.style.fontSize = EmscriptenInput.fontSizeBase * scale + 'px';

    var resize = EmscriptenInput.iframe_current.contentWindow.resize;
    if (resize) {
        resize();
    }
}

window.addEventListener('resize', EmscriptenInput.resize, true);
document.addEventListener('webkitfullscreenchange', EmscriptenInput.resize, false);
document.addEventListener('mozfullscreenchange', EmscriptenInput.resize, false);
document.addEventListener('fullscreenchange', EmscriptenInput.resize, false);
document.addEventListener('MSFullscreenChange', EmscriptenInput.resize, false);

EmscriptenInput.showInputField = function(x, y, w, h, fontSize, multiline) {
    EmscriptenInput.closeInputField();
    EmscriptenInput.iframe_current = multiline ? EmscriptenInput.iframe_multiline : EmscriptenInput.iframe_singleline;
    EmscriptenInput.xIframeBase = x;
    EmscriptenInput.yIframeBase = y;
    EmscriptenInput.wIframeBase = w
    EmscriptenInput.hIframeBase = h + fontSize * 0.1;
    EmscriptenInput.hTextBase = h;
    EmscriptenInput.fontSizeBase = fontSize;
    EmscriptenInput.initialValue = "";

    var iframe = EmscriptenInput.iframe_current;
    iframe.style.visibility = "visible";
    var obj = iframe.contentDocument.getElementById('inputfield');
    obj.value = "";

    // coordinates and sizes passed from lua is in the current canvas space
    // e.g. if canvas.width or canvas.height are changed in fullscreen,
    // those values will be different too
    EmscriptenInput.scaleBase = EmscriptenFullscreen.getCanvasScale();
    EmscriptenInput.resize();

    setTimeout(function() {
        obj.focus();
        obj.setSelectionRange(0, 10000);
    }, 0);
}

EmscriptenInput.closeInputField = function() {
    var iframe = EmscriptenInput.iframe_current;
    if (iframe == null)
        return;
    iframe.style.visibility = "hidden";
    iframe.style.width = "0px"; //bug on safari 13 still shows hidden iframe
    iframe.style.height = "0px";

    // ensure that input field could be focused again
    var obj = iframe.contentDocument.getElementById('inputfield');
    obj.blur();

    // ensure that canvas will have focus after closing input field
    setTimeout(function() {
        try {
            document.activeElement.blur();
        } catch (_) {} // IE thows "Incorrect function" when blur is callend on an hidden element
    }, 0);
}

EmscriptenInput.init = function(text, maxLength) {
    EmscriptenInput.initialValue = text;
    EmscriptenInput.setValue(text);
    EmscriptenInput.setMaxLength(maxLength);
}

EmscriptenInput.setValue = function(text) {
    var obj;
    obj = EmscriptenInput.iframe_current;
    if (!obj)
        return;
    obj = obj.contentDocument;
    if (!obj)
        return;
    obj = obj.getElementById('inputfield');
    if (!obj)
        return;
    obj.value = text;

    var resize = EmscriptenInput.iframe_current.contentWindow.resize;
    if (resize) {
        resize();
    }
}

EmscriptenInput.setMaxLength = function(maxLength) {
    var iframe = EmscriptenInput.iframe_current;
    if (!iframe)
        return;
    var obj = iframe.contentDocument.getElementById('inputfield');
    obj.maxLength = maxLength != -1 ? maxLength : 10000; // default is 524288, but Chrome input lags on such a big input
}


//////////////////
// WEBPACK FOOTER
// /src/src/casino/Application.emscriptenInput.js
// module id = 20
// module chunks = 0